import { render, staticRenderFns } from "./ProtocolDetails.vue?vue&type=template&id=74e8b078&scoped=true"
import script from "./ProtocolDetails.vue?vue&type=script&lang=js"
export * from "./ProtocolDetails.vue?vue&type=script&lang=js"
import style0 from "./ProtocolDetails.vue?vue&type=style&index=0&id=74e8b078&prod&scoped=true&lang=css"
import style1 from "./ProtocolDetails.vue?vue&type=style&index=1&id=74e8b078&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e8b078",
  null
  
)

export default component.exports